
import React from 'react';
import PropTypes from 'prop-types';

import './../Navigation.scss';

var TopNavBar = function TopNavBar(_ref) {
    var children = _ref.children;

    return React.createElement(
        'div',
        { className: 'top-nav-bar' },
        children
    );
};

TopNavBar.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * Children components
     */
    children: PropTypes.element
} : {};
export default TopNavBar;